<template>
	<div class="container__crudform">
		<div class="container__crudform__crud">
			<div
				data-testid="crudform-component"
				:class="['container__crudform__panel', { container__crudform__panel__visible: isVisible }]"
			>
				<i
					v-show="visibleIcon"
					class="fas fa-times float-right cursor-pointer"
					@click="changeIsVisible"
				/>
				<slot name="stepper" />
				<div class="container__crudform__titleclose">
					<label class="container__crudform__titleclose__title"> {{ titleForm }}</label>
				</div>
				<div class="container__crudform__actions">
					<slot name="actions" />
				</div>
				<div class="container__crudform__form">
					<slot name="form" />
				</div>
			</div>
		</div>
		<div
			v-show="backdrop && isVisible"
			data-testid="backdrop"
			class="container__crudform__backdrop__visible"
			@click="changeIsVisible"
		/>
	</div>
</template>

<script>
export default {
	props: {
		changeIsVisible: Function,
		backdrop: {
			type: Boolean,
			default: false,
		},
		visibleIcon: {
			type: Boolean,
			default: true,
		},
		isVisible: {
			type: Boolean,
			default: true,
		},
		titleForm: String,
	},
}
</script>

<style scoped>
.container__crudform__panel {
	position: fixed;
	background-color: white;
	top: 4rem;
	bottom: 5rem;
	right: -105%;
	height: 100vh;
	width: 100vw;
	transition: all 0.2s ease-in-out;
	color: rgb(var(--color-primary));
	font-size: 0.75rem;
	padding: 1rem;
	overflow-y: auto;
	z-index: 200;
	border-radius: 5px;
	margin-bottom: 40px;
}

.container__crudform__panel__visible {
	right: 0;
}

.container__crudform__titleclose {
	display: flex;
	justify-content: space-between;
	align-items: center;
	user-select: none;
}

.container__crudform__titleclose i {
	cursor: pointer;
	padding: 0.5rem 0 0.5rem 1rem;
}

.container__crudform__titleclose__title {
	font-size: 1.5rem;
	font-weight: 700;
}

.container__crudform__actions {
	justify-content: center;
	width: 100%;
	flex-wrap: wrap;
}

@media screen and (min-width: 992px) {
	.container__crudform__titleclose__title {
		font-size: 1.1rem;
	}
	.container__crudform__panel {
		height: 90vh;
		margin-right: 10px;
		margin-top: 10px;
	}
	.container__crudform__panel__visible {
		width: 40%;
	}
	.container__crudform__backdrop__visible {
		position: fixed;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		background-color: rgba(0, 0, 0, 0.2);
		z-index: 100;
	}
}

@media screen and (min-width: 1200px) {
	.container__crudform__panel__visible {
		width: 30%;
	}
}
</style>
